import { Reveal, Overline } from "../components/Reveal";
import { LogoStacked } from "../components/Logo";

export default function About({ content }) {
  return (
    <section id="about" className="scroll-mt-20 py-24 sm:py-32" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <Reveal>
          <div className="relative">
            <div className="absolute inset-0 translate-x-4 translate-y-4 border border-electric/40 pointer-events-none" />
            <div className="relative border border-white/10 bg-black flex items-center justify-center p-12 sm:p-16">
              <LogoStacked className="w-full max-w-sm h-auto" />
            </div>
            <div className="absolute -bottom-5 left-6 bg-electric px-5 py-3 shadow-[0_0_28px_rgba(6,69,243,0.4)]">
              <p className="text-[10px] font-bold uppercase tracking-[0.3em] text-white">Rochdale · Est. Greater Manchester</p>
            </div>
          </div>
        </Reveal>
        <div>
          <Reveal>
            <Overline>About Us</Overline>
            <h2 className="mt-4 font-display text-4xl sm:text-5xl font-semibold tracking-tight uppercase leading-[1.02] text-white">
              {content.about.title || "Obsessed with performance."}
            </h2>
          </Reveal>
          {content.about.paragraphs.map((p, i) => (
            <Reveal key={i} delay={0.1 + i * 0.08}>
              <p className="mt-6 text-sm sm:text-base text-gray-400 leading-relaxed">{p}</p>
            </Reveal>
          ))}
          <Reveal delay={0.35}>
            <div className="mt-9 flex flex-wrap gap-3">
              {content.services.map((s) => (
                <span key={s.id} className="text-[11px] font-bold uppercase tracking-[0.2em] border border-white/15 text-gray-300 px-4 py-2">
                  {s.title}
                </span>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
